import { render, staticRenderFns } from "./diet.vue?vue&type=template&id=9243aeee&"
import script from "./diet.vue?vue&type=script&lang=js&"
export * from "./diet.vue?vue&type=script&lang=js&"
import style0 from "./diet.vue?vue&type=style&index=0&id=9243aeee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports